import { getEfsunTypeLabel, formatEfsunValue, getEfsunValueColorClass } from './armorEfsunUtils';
import { translateGameText, tInventory } from './gameTextI18n';

const statName = (name) => translateGameText('statNames', name, name);

export const buildDetailedStatRows = (item, options = {}) => {
  if (!item) return [];

  const {
    showDescription = false,
    showDropSources = false,
    platingBonusPercent = 0
  } = options;

  const getValue = (keys) => {
    for (const key of keys) {
      if (item[key] !== undefined && item[key] !== null) return item[key];
    }
    return undefined;
  };

  const withPlatingBonus = (valueText) => {
    if (!platingBonusPercent) return valueText;
    return {
      text: valueText,
      bonusText: `(+${platingBonusPercent}%)`,
      bonusClass: 'item-plating-stat-bonus'
    };
  };

  const pushRow = (rows, label, value) => {
    if (value && typeof value === 'object' && value.text !== undefined) {
      rows.push({ label, value: value.text, bonusText: value.bonusText, bonusClass: value.bonusClass });
      return;
    }
    rows.push({ label, value });
  };

  const rows = [];
  const attackMin = getValue(['attackMin', 'attack_min']);
  const attackMax = getValue(['attackMax', 'attack_max']);
  const magicAttackMin = getValue(['magicAttackMin', 'magic_attack_min']);
  const magicAttackMax = getValue(['magicAttackMax', 'magic_attack_max']);
  const defense = getValue(['defense']);
  const attackSpeed = getValue(['attackSpeed', 'attack_speed']);
  const moveSpeed = getValue(['moveSpeed', 'move_speed']);
  const value = getValue(['value']);
  const statType = getValue(['statType', 'stat_type']);
  const statValue = getValue(['statValue', 'stat_value']);
  const stat1Id = getValue(['stat1Id', 'stat1_id']);
  const stat1Type = getValue(['stat1Type', 'stat1_type']);
  const stat1Value = getValue(['stat1Value', 'stat1_value']);
  const stat2Type = getValue(['stat2Type', 'stat2_type']);
  const stat2Value = getValue(['stat2Value', 'stat2_value']);
  const count = getValue(['count', 'Count']);
  const droppedBy = getValue(['droppedBy', 'dropped_by']);
  const categoryLabel = getValue(['categoryLabel']);
  const description = getValue(['description']);

  if (attackMin !== undefined || attackMax !== undefined) {
    pushRow(rows, tInventory('statRowAttack', 'Saldırı'), withPlatingBonus(`${attackMin ?? 0} - ${attackMax ?? 0}`));
  }
  if (magicAttackMin !== undefined || magicAttackMax !== undefined) {
    pushRow(rows, tInventory('statRowMagicAttack', 'Büyü Saldırı'), withPlatingBonus(`${magicAttackMin ?? 0} - ${magicAttackMax ?? 0}`));
  }
  if (defense !== undefined) {
    pushRow(rows, tInventory('statRowDefense', 'Savunma'), withPlatingBonus(defense));
  }
  if (attackSpeed !== undefined) {
    rows.push({ label: tInventory('statRowAttackSpeed', 'Saldırı Hızı'), value: attackSpeed });
  }
  if (moveSpeed !== undefined) {
    rows.push({ label: tInventory('statRowMoveSpeed', 'Hareket Hızı'), value: moveSpeed });
  }
  if (statType !== undefined && statValue !== undefined) {
    pushRow(rows, statName(statType), withPlatingBonus(statValue));
  }
  if (stat1Type !== undefined && stat1Value !== undefined) {
    const shieldPctById = stat1Id === 16;
    const shieldPctByLabel =
      typeof stat1Type === 'string' && stat1Type === 'Canavarlara Karşı Savunma';
    const baseVal = shieldPctById || shieldPctByLabel ? `+${stat1Value}%` : stat1Value;
    pushRow(rows, statName(stat1Type), withPlatingBonus(baseVal));
  }
  if (stat2Type !== undefined && stat2Value !== undefined) {
    pushRow(rows, statName(stat2Type), withPlatingBonus(stat2Value));
  }
  if (value !== undefined) {
    rows.push({ label: categoryLabel === 'Diğer' ? tInventory('statRowSellPrice', 'Satış Fiyatı') : tInventory('statRowValue', 'Değer'), value: categoryLabel === 'Diğer' ? `${value} Yang` : value });
  }
  if (showDescription && description !== undefined && String(description).trim() !== '') {
    rows.push({ label: tInventory('statRowDescription', 'Açıklama'), value: description });
  }
  if (count !== undefined) {
    rows.push({ label: tInventory('statRowCount', 'Adet'), value: count });
  }
  if (showDropSources && Array.isArray(droppedBy) && droppedBy.length > 0) {
    rows.push({ label: tInventory('statRowDroppedBy', 'Hangi canavardan elde edilir?'), value: droppedBy.join(', ') });
  }

  return rows;
};

export const buildEfsunRows = (efsunlar, profileName = 'armor') => {
  if (!Array.isArray(efsunlar) || efsunlar.length === 0) return [];
  return efsunlar.map((efsun, index) => {
    const label = getEfsunTypeLabel(efsun.type);
    const value = `${formatEfsunValue(efsun.type, efsun.value)}${efsun.tier ? ` (T${efsun.tier})` : ''}`;
    return {
      label: tInventory('statRowEfsun', `Efsun ${index + 1}: ${label}`, { n: index + 1, label }),
      value,
      colorClass: getEfsunValueColorClass(efsun.type, efsun.value, efsun.tier, profileName),
      isEfsun: true
    };
  });
};
